import {AccountLookupResult} from "./types";

export function createVeriflytCheckResultValidator(resultGetter: () => AccountLookupResult) {
    return function validateVeriflytCheckResult(rule, value, callback) {

        const result = resultGetter();

        if (value?.willGenerate){
            callback(); // If willGenerate is true, skip validation
            return;
        }

        // If inputValue is empty, skip validation if not required.
        if (!value?.inputValue) {
            if (rule.required){
                callback('Veriflyt ID is required (Removing existing ID not allowed)');
            }
            else{
                callback();
            }
            return;
        }

        if (result.error) {
            callback('Failed to validate Veriflyt ID');
            return;
        }

        if (!result.loading && (!result.account || (!result.account.primaryName && !result.account.secondaryName))) {
            callback('Unknown Veriflyt ID');
            return;
        }

        // If all checks pass, call the callback with no error
        callback();

    }
}

export function validateVeriflytID(veriflytPrefix: 'P' | 'A' | 'B' | 'C' | 'D' | 'E') {
    return function (rule, value, callback) {
        if (value?.willGenerate) {
            callback(); // If willGenerate is true, skip validation
            return;
        }

        // If inputValue is empty, skip validation
        if (!value?.inputValue) {
            callback();
            return;
        }

        const pattern = new RegExp(`^${veriflytPrefix}\\d{10}$`);
        if (pattern.test(value?.inputValue)){
            callback();
        }
        else {
            callback(`Veriflyt ID must start with "${veriflytPrefix}" followed by 10 digits`);
        }
    }
}